import { css, cva } from '@/styled-system/css';

export const tooltipContentRecipe = cva({
  base: {
    maxInlineSize: '360px',
    color: 'text.neutral',
    textStyle: 'body',
    backgroundColor: 'bg.elevated.mediumShadow',
    borderRadius: 'Tooltip',
    paddingInline: {
      base: 'tighter',
      lg: 'default',
    },
    paddingBlock: {
      base: 'tightest',
      lg: 'tighter',
    },
    filter: 'drop-shadow({shadows.Tooltip})',
    willChange: 'filter',
    transitionProperty: {
      _motionReduce: 'none',
      _motionSafe: 'opacity, transform',
    },
    transitionDuration: {
      _motionReduce: '0s',
      _motionSafe: '{durations.250}',
    },
    transitionTimingFunction: '{easings.ease}',
  },
  variants: {
    open: {
      true: {
        opacity: 1,
        transform: 'none',
      },
      false: {
        opacity: 0,
        transform: 'scale(0.975)',
      },
    },
  },
});

export const tooltipContentPositionerStyles = css.raw({
  zIndex: 'tooltip',
});
